import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { Loading } from '../../loading'
import { AddToAll } from './AddToAll'
import { PortfolioList } from './PortfolioList'
import { RemoveFromAll } from './RemoveFromAll'
import { SearchBox } from './SearchBox'
import classes from './index.module.scss'
import { resetStore, selectLoading } from './store/slice'
import { getPortfolioByOrgId } from './store/thunk'
import { CreatePortfolio } from './CreatePortfolio'

export const Content = () => {
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()
  const organizationId = Number(searchParams.get('organizationId'))
  const isLoading = useSelector(selectLoading('portfolios'))

  useEffect(() => {
    dispatch(getPortfolioByOrgId({ OrganizationId: organizationId }))
  }, [organizationId])

  useEffect(() => {
    return () => dispatch(resetStore())
  }, [])

  return (
    <>
      {isLoading && <Loading />}
      <div style={{ opacity: isLoading ? 0 : 1 }}>
        <div
          style={{ paddingBottom: 12 }}
          className="dFlex cursorPointer alignItemsCenter"
        >
          <SearchBox />
          <CreatePortfolio organizationId={organizationId} />
        </div>

        <div className={classes.buttonGroup}>
          <AddToAll organizationId={organizationId} />
          <RemoveFromAll organizationId={organizationId} />
        </div>

        <PortfolioList organizationId={organizationId} />
      </div>
    </>
  )
}
